@if (taLoaded()) {
  <div class="w-full h-full">
    @switch (currentStep()?.code) {
      @case (CreateTaStepType.DETAILS) {
        <create-ta-details [isReadOnly]="isReadOnly()"></create-ta-details>
      }
      @case(CreateTaStepType.TRAVELLERS) {
        <create-ta-travellers [isReadOnly]="isReadOnly()"></create-ta-travellers>
      }
      @case(CreateTaStepType.ITINERARY) {
        <create-ta-itinerary [isReadOnly]="isReadOnly()" [selectedTravellerId]="travellerId()" (selectedTravellerIdChange)="travellerIdChange.emit($event)"></create-ta-itinerary>
      }
      @case(CreateTaStepType.DOCUMENTATION) {
        <create-ta-documentation [isReadOnly]="isReadOnly()"></create-ta-documentation>
      }
      @default {
        <create-ta-details [isReadOnly]="isReadOnly()"></create-ta-details>
      }
    }
  </div>
}
